import React from 'react'
import './about.css'
import ME from '../../assets/mypicture.jpeg'
import {FaAward} from 'react-icons/fa'
import {TbCertificate} from 'react-icons/tb'
import {VscFolderLibrary} from 'react-icons/vsc'


const about = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>1+ Years Working</small>
            </article>

            <article className='about__card'>
              <TbCertificate className='about__icon'/>
              <h5>Certificates</h5>
              <small>20+ Certificates Achieved</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>2+ Completed</small>
            </article>
          </div>

          <p>
            Enthusiastic professional and recent graduate with a degree in Information Technology.
            People-focused and logical, intuitive, and responsive to challenges by analyzing complex data,
            devising solutions, and enhancing business success, Works exceptionally well in fast-paced environments
            with a proven ability to respond to unforeseen situations in a calm, organized, and effective manner.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default about